import { useState, useEffect } from "react"
import { useAppSelector } from "../../../../../store/storeHooks"
import { selectEffectiveUserType } from "../../../../../context/contextSelectors"
import { SubscriptionsFilterProps } from "../components/FiltersDrawersSubscriptions"

const useActiveFiltersCount = (filters: SubscriptionsFilterProps) => {
    const [activeCounts, setActiveCounts] = useState({
        merchantActive: 0,
        orderActive: 0,
        periodActive: 0,
        debtorActive: 0,
        endUserActive: 0,
        paymentActive: 0,
    })

    const currentUserType = useAppSelector(selectEffectiveUserType)

    useEffect(() => {
        const countActiveFilters = (conditions: any[]) => conditions.filter(Boolean).length

        const orderActiveCount = countActiveFilters([filters.orderId])
        const merchantActiveCount = countActiveFilters([
            filters.merchantIds && filters.merchantIds.length > 0,
            filters.shopIds && filters.shopIds.length > 0,
            filters.subscriptionIds && filters.subscriptionIds.length > 0,
        ])

        const periodActiveCount = countActiveFilters([filters.startDate, filters.endDate])

        const debtorActiveCount = countActiveFilters([filters.customerId])
        const endUserActiveCount = countActiveFilters([filters.email, filters.employeeId])

        const paymentActiveCount = countActiveFilters([
            filters.creditCardLast4,
            filters.paymentMethods && filters.paymentMethods.length > 0,
        ])

        setActiveCounts({
            merchantActive: merchantActiveCount,
            orderActive: orderActiveCount,
            periodActive: periodActiveCount,
            debtorActive: debtorActiveCount,
            endUserActive: endUserActiveCount,
            paymentActive: paymentActiveCount,
        })
    }, [filters, currentUserType])

    const totalActiveCount = Object.values(activeCounts).reduce((sum, count) => sum + count, 0)

    return {
        activeCount: totalActiveCount,
        ...activeCounts,
    }
}

export default useActiveFiltersCount
